import React from "react";
import styles from "./index.module.scss";
import Link from "next/link";
const Chat = ({ chatUrl, showChat = true }) => {
  return (
    <div className={`${styles.wrapper} print:hidden`}>
      <Link
        className={`koh-fixed-find-store-btn ${!showChat ? "bottom-[11px]" : "bottom-[70px]"}`}
        href="/storelocator"
      >
        <span className="icon koh-icon-envelope"></span>
        <span className="find-store-text">Find A Store</span>
      </Link>

      {showChat && (
        <a className="kohWhatsAppBtn" href={chatUrl} target="_blank">
          <span className="icon koh-icon-envelope"></span>
          <span className="chat-btn-text">Chat</span>
        </a>
      )}
    </div>
  );
};

export default Chat;
